export default __webpack_public_path__ + "static/media/Witbooker_+_ES.c01f2c5d.png";